import Link from "next/link";
import { Box, Heading, Text } from "src/components/UI";
import { useWindowSize } from "src/hooks/useWindowSize";

type Section = {
  title: string;
  items: Array<Item>;
};

type Item = {
  label: string;
  slug: string;
  length: number;
};

type DirectDebitStepSectionProps = {
  sections: Array<Section>;
  render: JSX.Element;
  selectedItem: Item;
};

const DirectDebitStepSection = (props: DirectDebitStepSectionProps) => {
  const { sections, render, selectedItem } = props;

  const { isMobile } = useWindowSize();

  return (
    <Box>
      <Heading
        fontFamily="Roboto, sans-serif"
        fontSize={["24px", "20px"]}
        fontWeight={["700", "700"]}
        lineHeight={["28px", "24px"]}
        letterSpacing={["-0.24px", "-0.16px"]}
        textAlign={["left", "left"]}
        padding={["16px"]}
        color={["#404040"]}
      >
        Cara Daftar Bayar Otomatis
        <Box
          as="hr"
          marginTop={["16px", "16px"]}
          width={["100%", "100%"]}
          height={["1px", "2px"]}
          border={["none", "none"]}
          backgroundColor={["#F4F4F4", "#EDEDED"]}
        />
      </Heading>
      <Box
        flexDirection={["column", "row"]}
        gap={["unset", "16px"]}
        alignItems={["flex-start"]}
      >
        <Box
          width={["auto", "100%"]}
          backgroundColor={["#F4F4F4"]}
          borderRadius={["8px"]}
          gap={["16px", "32px"]}
          padding={["16px"]}
          margin={["0 16px", "unset"]}
          flex={["unset", "3 0 416px"]}
        >
          {sections.map((section) => (
            <Box key={section.title} gap={["8px"]}>
              <Heading
                fontFamily="Roboto, sans-serif"
                fontWeight="700"
                fontSize={["17px", "20px"]}
                lineHeight={["24px", "24px"]}
                letterSpacing={["0px", "0px"]}
              >
                {section.title}
              </Heading>
              <Box gap={["8px", "16px"]}>
                {section.items.map((item) => (
                  <Text
                    key={item.label}
                    fontFamily="Roboto, sans-serif"
                    fontWeight="500"
                    fontSize={["16px", "17px"]}
                    lineHeight={["32px", "24px"]}
                    letterSpacing={["0.16px", "0px"]}
                    cursor="pointer"
                    {...(!isMobile && selectedItem.label == item.label
                      ? {
                          color: "#E11931",
                        }
                      : {
                          color: "#676767",
                        })}
                  >
                    <Link href={item.slug} style={{ color: "inherit" }}>
                      {item.label}
                    </Link>
                  </Text>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
        <Box flex={["unset", "6 1 auto"]} display={["unset", "unset"]}>
          {render}
        </Box>
      </Box>
    </Box>
  );
};

export default DirectDebitStepSection;
